import { builder, defaults } from 'common/js/configs/';
import { units } from 'common/js/configs/constants';
import { commonBlurEffect } from '../../common/common-blur-effect';

export const formatConfigUnmarshaller = {
  recommendedLinks: defaults.recommendedLinks,
  contentDiscovery: defaults.contentDiscovery,

  name: builder.string('name', {
    l:'',
    d:'',
    if: 'percent_show'
  }),
  orientation: builder.string('orientation', {
    of: ['auto', 'landscape', 'portrait'],
    possibleValues: [
      {
        name: 'Auto',
        value: 'auto'
      },
      {
        name: 'Landscape',
        value: 'landscape'
      },
      {
        name: 'Portrait',
        value: 'portrait'
      }
    ],
    defaultValue: 'auto',
    d:''
  }),

  forceDiscoverBrand: builder.boolean('force_discover_brand', {
    l:'',
    d:'',
    defaultValue: false
  }),

  ignoreClicksBefore: builder.number('ignore_clicks_before', {
    defaultValue: 250,
    d:'',
    unit: units.milliseconds
  }),

  // creative
  creative: builder.holder({
    backgroundColor: builder.color('creative_background_color', {
      defaultValue: '#FFFFFF',
      l:'',
      d:''
    }),
    backgroundOpacity: builder.number('creative_background_opacity', {
      d:'',
      defaultValue: 100,
      unit: units.percentage
    }),
    position: builder.string('creative_position', {
      of: ['top', 'center', 'bottom'],
      possibleValues: [
        {
          name: 'Top',
          value: 'top'
        },
        {
          name: 'Center',
          value: 'center'
        },
        {
          name: 'Bottom',
          value: 'bottom'
        }
      ],
      d:'',
      defaultValue: 'top'
    }),
    creativeCover: builder.boolean('creative_cover', {
      d:'',
      defaultValue: false
    }),
    creative: builder.string('creative', {
      defaultValue: 'Image',
      of: ['Image', 'Url'],
      possibleValues: [
        {
          name: 'Image',
          value: 'Image'
        },
        {
          name: 'HTML',
          value: 'Url'
        }
      ],
      l:'',
      ignore: true
    }),
    smartphonePortrait: builder.string('small_portrait_creative', {
      overrideType: 'image',
      l:'',
      d:'',
      if: {
        valueOf: 'creative',
        is: 'Image'
      }
    }),
    tabletLandscape: builder.string('large_landscape_creative', {
      overrideType: 'image',
      l:'',
      d:'',
      if: {
        valueOf: 'creative',
        is: 'Image'
      }
    }),
    tabletPortrait: builder.string('large_portrait_creative', {
      overrideType: 'image',
      l:'',
      d:'',
      if: {
        valueOf: 'creative',
        is: 'Image'
      }
    }),
    previewUrl: builder.string('preview_url', {
      overrideType: 'urlFromZip',
      l:'',
      d:'',
      if: {
        valueOf: 'creative',
        is: 'Url'
      }
    })
  }),

  // percent
  discover: builder.holder({
    show: builder.boolean('percent_show', {
      defaultValue: true,
      l:'',
      d:''
    }),
    height: builder.number('percent_height', {
      defaultValue: 128,
      l:'',
      d:'',
      if: 'percent_show',
      unit: units.pixel
    }),
    backgroundColor: builder.color('percent_background_color', {
      defaultValue: '#FFFFFF',
      l:'',
      d:'',
      if: 'percent_show'
    }),
    fontColor: builder.color('percent_font_color', {
      defaultValue: '#444444',
      l:'',
      d:'',
      if: 'percent_show'
    }),
    uppercase: builder.boolean('percent_uppercase', {
      defaultValue: true,
      l:'',
      d:'',
      if: 'percent_show'
    })
  }),

  // Icon
  icon: builder.holder({
    useIcon: builder.boolean('use_icon', {
      defaultValue: true,
      l:'',
      d:''
    }),
    name: builder.string('icon_name', {
      l:'',
      d:'',
      if: 'use_icon'
    }),
    url: builder.icon('icon', {
      overrideType: 'image',
      l:'',
      d:'',
      if: 'use_icon'
    }),
    identifier: builder.string('identifier', {
      overrideType: 'hidden',
      l:'',
      d:'',
      if: 'use_icon',
      optional: true
    }),
    isAllowedAfterBrowser: builder.boolean('allow_icon_after_browser', {
      defaultValue: true
    }),
    bannerHeight: builder.number('icon_banner_height', {
      defaultValue: 96,
      l:'',
      d:'',
      if: 'use_icon',
      unit: units.pixel
    }),
    backgroundColor: builder.color('icon_banner_background_color', {
      defaultValue: '#AAAAAA',
      l:'',
      d:'',
      if: 'use_icon'
    }),
    size: builder.number('icon_size', {
      defaultValue: 75,
      l:'',
      d:'',
      if: 'use_icon',
      unit: units.pixel
    }),
    uppercase: builder.boolean('icon_uppercase', {
      defaultValue: true,
      l:'',
      d:'',
      if: 'use_icon'
    }),
    forceInstall: builder.boolean('icon_force_install', {
      defaultValue: false,
      l:'',
      d:'',
      if: 'use_icon'
    })
  }),

  // confirm button
  confirmButton: builder.holder({
    show: builder.boolean('confirm_button_show', {
      defaultValue: true,
      l:'',
      d:''
    }),

    height: builder.number('confirm_button_height', {
      defaultValue: 56,
      l:'',
      d:'',
      if: 'confirm_button_show',
      unit: units.pixel
    }),

    backgroundColor: builder.color('confirm_button_background_color', {
      defaultValue: '#FFFFFF',
      l:'',
      d:'',
      if: 'confirm_button_show'
    })
  }),

  ...commonBlurEffect,

  customTranslations: builder.object('translations', {
    defaultValue: {},
    d:''
  }),

  preventCloseBeforeLoad: builder.boolean('browser_prevent_close_before_load', {
    l:'',
    d:'' +
      'loading (the user will be able to close the browser after the delay set in ' +
      '"browser_force_close_display_after" no matter what)',
    defaultValue: true
  }),

  forceCloseDisplayAfter: builder.number('browser_force_close_display_after', {
    l:'',
    d:'',
    defaultValue: 5,
    unit: units.seconds
  })
};
